import { Navigate } from 'react-router-dom';
import { accountService, getRoleStrings } from '../../_services/accounts.service';

export function AuthRoute(params: {
    element: JSX.Element
}): JSX.Element {

    const currentUser = accountService.currentUserValue;
    const roles = getRoleStrings(currentUser);

    if (!currentUser || !currentUser.token || !roles.length) {
        return <Navigate to="/login" replace />;
    }

    return (params.element);
};

export default AuthRoute;